<template>
  <div v-if="source.kind" class="flex flex-col gap-1">
    <div class="flex items-center gap-2 min-w-0">
      <span :class="['rounded px-1.5 py-0.5 font-medium shrink-0', generic ? 'border border-dashed border-amber-400 bg-amber-50 text-amber-800 italic' : 'bg-blue-100 text-blue-800']">{{ generic ? source.kind : (source.kind === 'report' ? 'report' : source.kind) }}</span>
      <router-link v-if="to && source.label" :to="to" class="text-primary-600 no-underline hover:underline truncate">{{ source.label }}</router-link>
      <span v-else class="text-gray-900 truncate">{{ source.label || (source.id != null ? `#${source.id}` : '') }}</span>
    </div>
    <div v-if="source.metrics && source.metrics.length > 1" class="text-gray-500 pl-1">{{ source.metrics.length }} metrics: {{ source.metrics.join(', ') }}</div>
    <div v-if="source.via" class="text-gray-400 pl-1">{{ source.via }}</div>
  </div>
  <span v-else class="text-gray-400">&mdash;</span>
</template>

<script>
const STUDIO = {
  metric: 'metrics',
  metric_query: 'metrics',
  metric_alerts: 'metrics',
  metric_insights: 'metrics',
  metric_worklist: 'metrics',
  metric_worklist_columns: 'metrics',
  metric_patients: 'metrics',
  insight: 'metric-insights',
  worklist: 'worklists',
  patient_flag: 'patient-flags',
  data_attribute: 'data-attributes',
};
const GENERIC = new Set(['metric', 'metric_query', 'metric_alerts', 'metric_insights', 'metric_worklist', 'metric_worklist_columns', 'metric_patients', 'entity_parents', 'entity_levels']);

export default {
  name: 'SourceCell',
  props: { source: { type: Object, required: true } },
  computed: {
    generic() {
      return GENERIC.has(this.source.kind);
    },
    to() {
      const segment = STUDIO[this.source.kind];
      return segment && this.source.id != null ? `/tenantadmin/metric-studio/${segment}/${this.source.id}` : null;
    },
  },
};
</script>
